import { render } from "./PartsFirstView.vue?vue&type=template&id=52314440&scoped=true"
import script from "./PartsFirstView.vue?vue&type=script&lang=js"
export * from "./PartsFirstView.vue?vue&type=script&lang=js"

import "./PartsFirstView.vue?vue&type=style&index=0&id=52314440&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52314440"]])

export default __exports__